import { useHouseholdDetailsContext } from './householdDetails.context';

export function useRequiredHouseholdId() {
  const { householdId } = useHouseholdDetailsContext();

  if (!householdId) {
    throw new Error('Household ID is required in context, but was not found');
  }

  return householdId;
}
